'use strict';

export enum Feature {
  AccreditationSideMenu = 'ACCREDITATION_SIDE_MENU',
  Communities = 'COMMUNITIES',
  PublicFacingDocuments = 'PUBLIC_FACING_DOCUMENTS',
}
